import React, { FC } from 'react'
import { OrderCancelPolicyLeisureItem } from '~/app/components/order-cancel/hooks/useOrderCancelPolicy'
import LeisureCancelPolicy from '../../common/Leisure/LeisureCancelPolicy'
import { ItemState } from '~/app/components/order-cancel/orderItems/item'
import styled from '~/app/components/styled'

const OrderCancelLeisureCancelPolicyContainer = styled.div`
  & > span {
    width: 100%;
  }
`

interface Props {
  order: OrderCancelPolicyLeisureItem
  state: ItemState
}

const OrderCancelLeisureCancelPolicy: FC<Props> = ({ order: { product, variant }, state }) => {
  return (
    <OrderCancelLeisureCancelPolicyContainer>
      <LeisureCancelPolicy
        cancellationFeePlans={variant.cancellationFeePlans}
        refundInfo={product?.productInfo?.refundInfo}
        isAvailableUse={state === ItemState.CANCELABLE}
      />
    </OrderCancelLeisureCancelPolicyContainer>
  )
}

export default OrderCancelLeisureCancelPolicy
